import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import Btn, { BtnModifier } from '../../Btn';
import { ButtonType } from '../../../../types/ButtonType';
import { Icons } from '../../../atoms/SVG';
import { useDragAndDrop } from '../../../../_lib/DragAndDrop';
import { SortableListItemDragLayer } from './SortableListItemDragLayer';
import { ContentWrapperAction as Action } from '../../../blocks/ContentWrapper/ContentWrapper.types';

function SortableListItem({ id, name, moveUpButton, moveDownButton, moveItem, focusableItemId = null }) {
  const elementRef = useRef();
  const { isDragging, onDragStart, onDragEnter, onDragOver, onDragEnd } = useDragAndDrop(
    id,
    moveItem,
    SortableListItemDragLayer,
    { name }
  );

  useEffect(() => {
    if (id === focusableItemId) {
      elementRef.current?.focus();
    }
  }, [id, focusableItemId, elementRef]);

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <li
      ref={elementRef}
      className={`sortable-list__item${isDragging ? ' sortable-list__item--dragging' : ''}`}
      tabIndex="-1"
      onDragStart={onDragStart}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
      draggable
    >
      <div className="sortable-list__item-title">
        <span className="sortable-list__item-count" />
        {name}
      </div>
      <div className="sortable-list__item-buttons">
        <Btn
          id={`${Action.moveBlockDown}-${id}`}
          type={ButtonType.BUTTON}
          text={moveDownButton.text}
          titleText={moveDownButton.text}
          hiddenText
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
          svgSpriteId={Icons.MOVE_DOWN}
          ariaDisabled={moveDownButton.disabled}
          tooltipPlacement={TooltipPlacement.LEFT}
          onClick={() => moveItem(id, moveDownButton.targetId)}
        />
        <Btn
          id={`${Action.moveBlockUp}-${id}`}
          type={ButtonType.BUTTON}
          text={moveUpButton.text}
          titleText={moveUpButton.text}
          hiddenText
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
          svgSpriteId={Icons.MOVE_UP}
          ariaDisabled={moveUpButton.disabled}
          tooltipPlacement={TooltipPlacement.RIGHT}
          onClick={() => moveItem(id, moveUpButton.targetId)}
        />
      </div>
    </li>
  );
}

SortableListItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  moveItem: PropTypes.func.isRequired,
  focusableItemId: PropTypes.string,
  moveUpButton: PropTypes.shape({
    text: PropTypes.string,
    disabled: PropTypes.bool,
    targetId: PropTypes.string,
  }).isRequired,
  moveDownButton: PropTypes.shape({
    text: PropTypes.string,
    disabled: PropTypes.bool,
    targetId: PropTypes.string,
  }).isRequired,
};

export default SortableListItem;
